export const BILLING_ENDPOINTS = {
    // Analytics endpoints
    ANALYTICS_OVERVIEW: '/api/billing-analytics/overview',
    ANALYTICS_TRENDS: '/api/billing-analytics/trends', 
    ANALYTICS_PATTERNS: '/api/billing-analytics/patterns',
    
    // Messaging analytics
    MESSAGING_OVERVIEW: '/api/billing-analytics/messaging-overview',

    // Report generation
    GENERATE_REPORT: '/api/billing',
} as const;

// Helper function to format date for API
export const formatDateForAPI = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // YYYY-MM-DD format in local timezone
};

// Helper function to validate date range
export const validateDateRange = (startDate?: string, endDate?: string): { isValid: boolean; error?: string } => {
    if (!startDate && !endDate) {
        return { isValid: true }; // Both optional
    }
    
    if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            return { isValid: false, error: 'Invalid date format. Use YYYY-MM-DD.' };
        }
        
        if (start > end) {
            return { isValid: false, error: 'Start date must be before end date.' };
        }
    }
    
    return { isValid: true };
};

// Helper function to validate months parameter for trends
export const validateMonthsParam = (months?: number): { isValid: boolean; error?: string } => {
    if (months === undefined) {
        return { isValid: true }; // Optional parameter
    }
    
    if (!Number.isInteger(months) || months < 1 || months > 24) {
        return { isValid: false, error: 'Months must be an integer between 1 and 24.' };
    }
    
    return { isValid: true };
};
